/*
 * @Author: chenxuelai 2251702447@qq.com
 * @Date: 2023-07-05 09:21:29
 * @LastEditors: chenxuelai 2251702447@qq.com
 * @LastEditTime: 2023-10-17 10:04:09
 * @FilePath: /vue_huaqiang/src/router/modules/report-management.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {RouteConfig} from "vue-router";
import Layout from "@/layout/index.vue";

const customerCollectionManagement: RouteConfig[] = [
    {
        path: "customerCollectionManagement",
        component: Layout,
        redirect: "customerCollectionManagement",
        name: "customerCollectionManagement",
        meta: {
            title: "customerCollectionManagement",
            icon: "el-icon-s-goods",
            alwaysShow: true
        },
        children: [
          { // 报关合同号&IV清账
            path: "/iv-settle-account",
            name: "ivSettleAccount",
            component: () =>
              import("@/views-oms/collection-management/iv-settle-account.vue"),
            meta: { title: "ivSettleAccount",hidden: true, }
          },
          { // 客人IV管理
            path: "/customer-iv-management",
            name: "customerIvManagement",
            component: () =>
              import("@/views-oms/sales-order-management/customer/customer-iv-management.vue"),
            meta: { title: "customerIvManagement" }
          },
          {
            path: "/creditNoteManagement",
            name: "creditNoteManagement",
            meta: { title: "creditNoteManagement",},
            component: () =>
              import("@/views-oms/credit-note-management/credit-note/index.vue")
          },
          { // 客人IV管理-查看详情
            path: "/customer-iv-managementInfo",
            name: "customerIvManagementInfo",
            component: () =>
              import("@/views-oms/sales-order-management/customer/customer-iv-managementInfo.vue"),
            meta: { title: "customerIvManagementInfo",hidden: true, }
          }
        ]
    }
];

export default customerCollectionManagement;
